module.exports = __webpack_public_path__ + "static/media/forest1.78294685.png";